export class PipeMaterialConditionModel {
    _id: string;
    id: number;
    pipeMaterialId: number;
    expansionCoefficient: number;
    temperature: number;
    elasticityCoeficient: number;
    maxYealdStrength: number;
    safetyFactor: number;
    standard: string;

    constructor(_id = null,
        id = null,
        pipeMaterialId = null,
        expansionCoefficient = null,
        temperature = null,
        elasticityCoeficient = null,
        maxYealdStrength = null,
        safetyFactor = null,
        standard = null) {
            this._id = _id;
            this.id = id;
            this.pipeMaterialId = pipeMaterialId;
            this.expansionCoefficient = expansionCoefficient;
            this.temperature = temperature;
            this.elasticityCoeficient = elasticityCoeficient;
            this.maxYealdStrength = maxYealdStrength;
            this.safetyFactor = safetyFactor;
            this.standard = standard;
    }
}
